
import React from 'react';
import { SPACING } from '../../config/designSystem/Spacing';
import { SectionTitle } from '../Title/SectionTitle';
import { concatPath } from '../../utils/links/concatPath';
import { genericKey, libraryStackKey } from '../../constants/routeKeys';
import { marginHorizontalLibrary } from '../../constants/layout';
import { observer } from 'mobx-react';
import { router } from 'expo-router';
import { useStores } from '../../hooks/useStores';

export type SectionTitleProps ={
    categoryId: string,
    displayAll: boolean,}

const _ContentSectionTitle = ( { categoryId, displayAll} : SectionTitleProps) => {

  const {categories} = useStores();
  const category = categories.getCategory(categoryId);

  if(!category) return null;

  const goToGenericPage = () => {
    router.navigate({
      pathname: concatPath([libraryStackKey, genericKey]) as string,
      params : {
        id: categoryId
      }});
  };

  return (<SectionTitle style={{marginHorizontal: marginHorizontalLibrary, marginBottom: SPACING['sp-24'] }} title={category.title} subtitle={category?.subtitle} flower={'none'} displayAll={displayAll} onTouchDisplayAll={goToGenericPage}/>);


};

export const ContentSectionTitle = observer(_ContentSectionTitle);
